// extracted by mini-css-extract-plugin
export default {"control":"DropDown_control__VKmQZ","description":"DropDown_description__HEq5v","label":"DropDown_label__9LxHD","invalid":"DropDown_invalid__oFjga"};